<template>
    <div class="tracking-app">
        <a class="unregister button" @click.prevent="unregister">{{translationHelper.getTranslation("camp_tracking_button_unsubscription")}}</a>
        <!-- <a class="reset button" @click.prevent="reset">{{translationHelper.getTranslation("camp_tracking_button_reset")}}</a> -->
    </div>
</template>

<script>
import { TranslationHelper } from "../../../_Base/Utils";
import SiteCoreItem from "../../../_Api/SiteCoreItem";
export default {
    data() {
            return {
                translationHelper: {},
                neverPublishFlag: false,
                publishingStatus: ""
            }
        },
        created() {
            this.translationHelper = new TranslationHelper( this.$parent.$data.initialTranslations );
        },
        methods: {
            unregister() {
                document.cookie = 'ga-opt-out=true;expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
                //document.cookie = 'dcl-opt-out=true;expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
                window.location.reload( true );
            },
            reset() {
                localStorage.removeItem( 'cookieconsent' )
                document.cookie = 'ga-opt-out=false;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
                //document.cookie = 'dcl-opt-out=false;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
                window.cookieConsent();
            }
        }
}
</script>
